/**
 * Created by tombray on 11/24/14.
 */
var interceptor = require('rest/interceptor');
var when = require('when');

export default interceptor({
    request: function(request, config) {
        var headers = request.headers;
        headers['Accept'] = 'vnd.cargomatic+json;version=1';

        return request;
    }
});